export function getInputBiId(biId = ''): string | undefined {
	if (biId) {
		return `${biId}-autocomplete-single-input`;
	}
}
